/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ActualRegionalExposureMaxLimitViewModel
 */
export interface ActualRegionalExposureMaxLimitViewModel {
    /**
     * 
     * @type {number}
     * @memberof ActualRegionalExposureMaxLimitViewModel
     */
    percentage?: number;
    /**
     * 
     * @type {number}
     * @memberof ActualRegionalExposureMaxLimitViewModel
     */
    local?: number;
    /**
     * 
     * @type {number}
     * @memberof ActualRegionalExposureMaxLimitViewModel
     */
    foreign?: number;
}

/**
 * Check if a given object implements the ActualRegionalExposureMaxLimitViewModel interface.
 */
export function instanceOfActualRegionalExposureMaxLimitViewModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ActualRegionalExposureMaxLimitViewModelFromJSON(json: any): ActualRegionalExposureMaxLimitViewModel {
    return ActualRegionalExposureMaxLimitViewModelFromJSONTyped(json, false);
}

export function ActualRegionalExposureMaxLimitViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActualRegionalExposureMaxLimitViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'percentage': !exists(json, 'Percentage') ? undefined : json['Percentage'],
        'local': !exists(json, 'Local') ? undefined : json['Local'],
        'foreign': !exists(json, 'Foreign') ? undefined : json['Foreign'],
    };
}

export function ActualRegionalExposureMaxLimitViewModelToJSON(value?: ActualRegionalExposureMaxLimitViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Percentage': value.percentage,
        'Local': value.local,
        'Foreign': value.foreign,
    };
}

